import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { NavLink } from 'react-router-dom'

import { getCurrentOrganizationId } from '../../../../ducks/users'
import { fetchViews, getViews } from '../../../../ducks/views'

import Button from '../../../Shared/Button'

import styles from './Navigation.module.css'

export default function ViewNav() {
  const dispatch = useDispatch()
  const organizationId = useSelector(getCurrentOrganizationId)
  const views = useSelector(getViews(organizationId))

  useEffect(() => {
    dispatch(fetchViews(organizationId))
  }, [dispatch, organizationId])

  return (
    <div className={styles.wrapper}>
      <h5>Views</h5>
      <ul className={styles.items}>
        {views.map(view => (
          <li key={view.id} className={styles.item}>
            <NavLink
              to={`/databases/views/${view.id}`}
              className={styles.link}
              activeClassName={styles.active}
            >
              {view.name}
            </NavLink>
          </li>
        ))}
      </ul>
      <div className={styles.new}>
        <Button color="grey" to="/databases/create-view" icon="add">
          Create View
        </Button>
      </div>
    </div>
  )
}
